(function () {
  function scrub(root) {
    root.querySelectorAll('p').forEach(function (p) {
      if (p.textContent.replace(/ /g, ' ').trim() === '' && !p.querySelector('img')) { p.remove(); }
    });
  }

  function trimEdges(el) {
    while (el.firstChild && (el.firstChild.nodeName === 'BR' || (el.firstChild.nodeType === 3 && !el.firstChild.textContent.trim()))) {
      el.removeChild(el.firstChild);
    }
    while (el.lastChild && (el.lastChild.nodeName === 'BR' || (el.lastChild.nodeType === 3 && !el.lastChild.textContent.trim()))) {
      el.removeChild(el.lastChild);
    }
  }

  function fixInfoLinks(root) {
    root.querySelectorAll('a[href*="info-geometrische-vormen"]').forEach(function (a) {
      a.setAttribute('href', '/pages/info-geometrische-vormen');
      a.removeAttribute('target');
      a.removeAttribute('rel');
    });
  }

  function swapDescriptionImages() {
    var slots = document.querySelectorAll('.product-details .description_images img');
    if (!slots.length) return;
    var media = document.querySelectorAll('.product__media-list .product__media-item img');
    if (media.length < 2) return;
    var pick = [];
    if (media.length >= 3) { pick = [media[1], media[2]]; } else { pick = [media[1]]; }
    pick.forEach(function (srcImg, i) {
      if (!slots[i]) return;
      var url = srcImg.currentSrc || srcImg.src;
      if (!url) return;
      slots[i].removeAttribute('srcset');
      slots[i].removeAttribute('sizes');
      slots[i].src = url;
      if (srcImg.srcset) {
        slots[i].srcset = srcImg.srcset;
        slots[i].sizes = '(min-width: 990px) 420px, 100vw';
      }
    });
  }

  function enhance() {
    var d = document.querySelector('.product__description');
    if (!d || d.dataset.fdEnhanced) return;
    d.dataset.fdEnhanced = '1';
    fixInfoLinks(d);
    d.innerHTML = d.innerHTML.replace(/(?:\s*<br\s*\/?>\s*){3,}/gi, '<br><br>');
    scrub(d);
    var h1 = d.querySelector('h1');
    if (h1) h1.remove();
    var nodes = Array.prototype.slice.call(d.childNodes);
    var intro = document.createElement('div');
    intro.className = 'fd-desc-intro';
    var accWrap = document.createElement('div');
    accWrap.className = 'fd-acc-wrap';
    var currentBody = intro;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && /^H[2-4]$/.test(n.tagName)) {
        var det = document.createElement('details');
        det.className = 'fd-acc';
        var sum = document.createElement('summary');
        sum.className = 'fd-acc__summary';
        var label = document.createElement('span');
        label.textContent = n.textContent.trim();
        var icon = document.createElement('span');
        icon.className = 'fd-acc__icon';
        icon.setAttribute('aria-hidden', 'true');
        sum.appendChild(label);
        sum.appendChild(icon);
        det.appendChild(sum);
        var body = document.createElement('div');
        body.className = 'fd-acc__body';
        det.appendChild(body);
        accWrap.appendChild(det);
        currentBody = body;
      } else {
        currentBody.appendChild(n);
      }
    });
    trimEdges(intro);
    accWrap.querySelectorAll('.fd-acc__body').forEach(trimEdges);
    d.innerHTML = '';
    d.appendChild(intro);
    if (accWrap.children.length) {
      d.appendChild(accWrap);
      var first = accWrap.querySelector('details.fd-acc');
      if (first) first.open = true;
    }
    swapDescriptionImages();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fd-buynow]');
    if (!btn) return;
    e.preventDefault();
    var form = document.querySelector('form[action*="/cart/add"]');
    var id = form ? form.querySelector('[name="id"]') : null;
    if (!id || !id.value) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var label = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Bezig...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id.value, quantity: qty }] })
    }).then(function (r) {
      if (r.ok) { window.location.href = '/checkout'; }
      else { btn.removeAttribute('disabled'); btn.textContent = label; }
    }).catch(function () {
      btn.removeAttribute('disabled'); btn.textContent = label;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', enhance);
})();
